
import { defineComponent } from 'vue'
import { addOrRemove, contains, isSelectable, isMovable } from './selectedOperandService'
import { swap, move } from './advancedFilterService'
import { getFilterTree } from './treeService'
import QBEFilterDetail from './QBEFilterDetail.vue'

const crypto = require('crypto')
const deepEqual = require('deep-equal')

export default defineComponent({
    name: 'qbe-filter',
    components: { QBEFilterDetail },
    props: { propNode: { type: Object } },
    emits: ['selectedChanged', 'treeUpdated'],
    data() {
        return {
            node: {} as any,
            selected: false,
            dropzoneLeftVisible: false,
            dropzoneRightVisible: false,
            filterId: crypto.randomBytes(16).toString('hex')
        }
    },
    watch: {
        propNode: {
            handler() {
                this.loadNode()
            },
            deep: true
        }
    },
    async created() {
        this.loadNode()
    },
    methods: {
        loadNode() {
            this.node = this.propNode as any
        },
        onDragStart(event: any) {
            event.dataTransfer.setData('text/plain', JSON.stringify(this.node))
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
        },
        select(node) {
            addOrRemove(node)
            this.selected = this.isSelected()
            this.$emit('selectedChanged')
        },
        isSelected() {
            return contains(this.node)
        },
        isSelectable() {
            return isSelectable(this.node)
        },
        onDropComplete(event) {
            this.hideDropzone('left')
            const eventData = JSON.parse(event.dataTransfer.getData('text/plain'))
            if (!deepEqual(eventData, this.node)) {
                swap(getFilterTree(), eventData, this.node)
                this.$emit('treeUpdated')
            }
        },
        onDropMove(event) {
            this.hideDropzone('right')
            const eventData = JSON.parse(event.dataTransfer.getData('text/plain'))
            if (isMovable(eventData)) {
                if (!deepEqual(eventData, this.node)) {
                    move(getFilterTree(), eventData, this.node)
                    this.$emit('treeUpdated')
                }
            }
        },
        displayDropzone(position: string) {
            if (position === 'left') {
                this.dropzoneLeftVisible = true
            } else {
                this.dropzoneRightVisible = true
            }
            const id = `filter-${position}-${this.filterId}` as string
            ;(this.$refs as any)[id].classList.add('filter-dropzone-active')
        },
        hideDropzone(position: string) {
            if (position === 'left') {
                this.dropzoneLeftVisible = false
            } else {
                this.dropzoneRightVisible = false
            }
            const id = `filter-${position}-${this.filterId}` as string
            ;(this.$refs as any)[id].classList.remove('filter-dropzone-active')
        }
    }
})
